module.exports = __webpack_public_path__ + "app-static/img/btn_01.2951e7be.png";